import { ThemeConfig } from "antd";

import { fontTheme } from "./custom/font";
import { paletteTheme } from "./custom/palette";
import { typographyTheme } from "./custom/typography";
import { progressTheme } from "./overrides/components/progress";
import { tabTheme } from "./overrides/components/tab";
import { timelineTheme } from "./overrides/components/timeline";
import {
  alertTheme,
  buttonTheme,
  collapseTheme,
  inputNumberTheme,
  inputTheme,
  menuTheme,
  modalTheme,
  paginationTheme,
  selectTheme,
  stepsTheme,
  tableTheme,
  tagTheme,
} from "./overrides";

const theme: ThemeConfig = {
  token: {
    ...fontTheme,
    ...typographyTheme,
    ...paletteTheme,
    borderRadius: 10,
    borderRadiusLG: 10,
  },
  components: {
    Input: inputTheme,
    Select: selectTheme,
    Button: buttonTheme,
    Menu: menuTheme,
    Pagination: paginationTheme,
    Tag: tagTheme,
    Modal: modalTheme,
    Collapse: collapseTheme,
    Steps: stepsTheme,
    Progress: progressTheme,
    Tabs: tabTheme,
    Timeline: timelineTheme,
    InputNumber: inputNumberTheme,
    Alert: alertTheme,
    Table: tableTheme,
  },
};

export default theme;
